// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions / selectors
import { addCalcInfo } from './calc-info.actions';
const calcInfo = createReducer({}, on(addCalcInfo, (state, action) => {
    const nextState = { ...state };
    Object.keys(action.calcInfo).forEach((calcName) => {
        nextState[calcName] = action.calcInfo[calcName];
    });
    return nextState;
}));
export { calcInfo };
